























import { defineComponent, Ref, ref, watch } from '@vue/composition-api';
import ElColorPicker                        from 'element-ui/lib/color-picker';

export default defineComponent({
  name: 'cColorPicker',
  components: {
    ElColorPicker,
  },
  setup(props, context) {
    const colorPicker: Ref<{ showPicker: boolean } | null> = ref(null);

    watch(() => (colorPicker.value)?.showPicker, (value) => {
      if (value) {
        context.emit('onPickerShow');
      } else {
        context.emit('onPickerClose');
      }
    });

    return {
      colorPicker,
    };
  },
});
